import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ShieldCheck, Instagram } from 'lucide-react';
import { Button } from './ui/Button';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const Hero = () => {
  return <section className="relative min-h-[82vh] sm:min-h-[90vh] flex items-center pt-24 pb-14 lg:pt-0 lg:pb-0 overflow-hidden bg-navy-900" data-id="element-193">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-194">
        <img src="https://cdn.magicpatterns.com/uploads/2o5CxhcoxBYbDsJ4WZb32h/11_jun_2026,_15_48_03.png" alt="Tratamiento de depilación láser con tecnología Soprano Titanium" className="w-full h-full object-cover object-[75%_center] sm:object-right opacity-50 sm:opacity-70" data-id="element-195" />
        <div className="absolute inset-0 bg-navy-900/70 sm:bg-transparent" data-id="element-196"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900 via-navy-900/80 to-transparent" data-id="element-197"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-198">
        <div className="max-w-2xl mx-auto sm:mx-0" data-id="element-199">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center sm:text-left" data-id="element-200">
            <motion.div animate={{
            boxShadow: ['0 0 0 0 rgba(58,107,165,0)', '0 0 22px 2px rgba(58,107,165,0.45)', '0 0 0 0 rgba(58,107,165,0)']
          }} transition={{
            duration: 2.6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-500/20 border border-brand-500/40 text-brand-100 text-xs sm:text-sm font-medium mb-4 sm:mb-6" data-id="element-201">
              <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-202" />
              Tecnología Láser Soprano
            </motion.div>

            <h1 className="text-2xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-3 sm:mb-4 break-words" data-id="element-203">
              Depilación Láser{' '}
              <span className="sm:whitespace-nowrap" data-id="element-204">
                Soprano <span className="text-white" data-id="element-205">en</span>{' '}
                <span className="text-brand-500" data-id="element-206">Montevideo</span>
              </span>
            </h1>

            <div className="text-base sm:text-xl text-slate-300 leading-relaxed font-semibold mb-4 sm:mb-6" data-id="element-207">
              <p data-id="element-208">
                Resultados visibles desde{' '}
                <span className="block sm:inline" data-id="element-209">las primeras sesiones,</span>
              </p>
              <p data-id="element-210">sin dolor y para todo tipo de piel.</p>
            </div>

            <p className="text-sm sm:text-lg text-slate-400 mb-6 sm:mb-8 leading-relaxed" data-id="element-211">
              Evaluación gratuita, tratamiento personalizado y tecnología
              Soprano para lograr una reducción efectiva del vello de forma
              cómoda y segura.
            </p>

            <div className="flex justify-center sm:justify-start mb-7 sm:mb-10" data-id="element-212">
              <a href={getWhatsAppUrl('Hola! Vengo de la web y me gustaría reservar una consulta gratuita.')} target="_blank" rel="noopener noreferrer" data-id="element-213">
                <Button variant="whatsapp" size="sm" className="gap-2 text-sm sm:text-base px-5 py-2.5 sm:px-8 sm:py-4" data-id="element-214">
                  <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-215" />
                  Reserva tu consulta gratuita
                </Button>
              </a>
            </div>

            <div className="flex flex-row flex-wrap items-center justify-center sm:justify-start gap-x-5 gap-y-2 sm:gap-6 text-xs sm:text-sm text-slate-400" data-id="element-216">
              <div className="flex items-center gap-2" data-id="element-217">
                <motion.span animate={{
                filter: ['drop-shadow(0 0 0px rgba(58,107,165,0))', 'drop-shadow(0 0 8px rgba(58,107,165,0.9))', 'drop-shadow(0 0 0px rgba(58,107,165,0))']
              }} transition={{
                duration: 2.2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="inline-flex" data-id="element-218">
                  <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-brand-500" data-id="element-219" />
                </motion.span>
                <span data-id="element-220">Homologado por MSP</span>
              </div>
              <a href="https://instagram.com/depilacion.laseruruguay" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" aria-label="Ir al Instagram @depilacion.laseruruguay" data-id="element-221">
                <motion.span animate={{
                filter: ['drop-shadow(0 0 0px rgba(58,107,165,0))', 'drop-shadow(0 0 8px rgba(58,107,165,0.9))', 'drop-shadow(0 0 0px rgba(58,107,165,0))']
              }} transition={{
                duration: 2.2,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.6
              }} className="inline-flex" data-id="element-222">
                  <Instagram className="w-4 h-4 sm:w-5 sm:h-5 text-brand-500" data-id="element-223" />
                </motion.span>
                <span data-id="element-224">@depilacion.laseruruguay</span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};